import { render, staticRenderFns } from "./GravarVisitaDialog.vue?vue&type=template&id=27a54322&"
import script from "./GravarVisitaDialog.vue?vue&type=script&lang=js&"
export * from "./GravarVisitaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports